import { axiosInstance } from '../common/api';

export const createClient = (data) => {
  const url = `/client/add`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getClients = ({ start, pageSize, filters, globalFilter, sorting }) => {
  let url = `/client/?`;
  if (pageSize) url += `pageSize=${pageSize}&`;
  if (start) url += `start=${start}&`;
  if (filters) url += `filters=${filters}&`;
  if (globalFilter) url += `globalFilter=${globalFilter}&`;
  if (sorting) url += `sorting=${sorting}&`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getAllClients = () => {
  const url = `/client/?pageSize=all`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const filterClientList = () => {
  const url = `/client/filter`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const updateClient = (id, data) => {
  const url = `/client/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const deleteClient = (id) => {
  const url = `/client/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
